import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 10"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5 5.45V3.207m0 3.905v.02M7.52 9H2.48c-.688 0-1.27-.512-1.452-1.212-.078-.3.018-.61.164-.876l2.52-5.111c.59-1.068 1.985-1.068 2.576 0l2.52 5.111c.146.266.242.577.164.876C8.79 8.488 8.208 9 7.52 9"
    }, null, -1)
  ]))]))
}
export default { render: render }